export interface OptionType {
  title: string
  name: string
  selected: boolean
}

export type Filter = {
  title: string
  options: Array<OptionType>
}

export const isAtLeastOneFilterApplied = (filters: Filter[]) =>
  filters?.reduce(
    (acc, { options = [] }) => [
      ...acc,
      ...options.filter(({ selected }) => selected),
    ],
    []
  ).length > 0

export const isAtLeastOneFilterAppliedByTitle = (
  title: string,
  filters: Filter[]
) =>
  filters
    .find(({ title: t }) => t === title)
    ?.options.find(({ selected }) => selected) !== undefined

export const shouldNotFilterBike = (
  title: string,
  optionName: string,
  filters: Filter[]
) => {
  const filterer = filters.find((f) => title === f.title)
  const options = filterer?.options.filter((f) => f.selected)
  return (
    options?.find(
      ({ name }) => name?.toLowerCase() === optionName?.toLowerCase()
    ) !== undefined
  )
}

export const toggleSelected = (
  title: string,
  name: string,
  filters: Filter[],
  setFilters: (filters: Filter[]) => void
) => {
  setFilters(
    filters.map((filter) => {
      if (title === filter.title) {
        return {
          ...filter,
          options: filter.options.map((opt) => {
            if (opt.name === name) {
              return {
                ...opt,
                selected: !opt.selected,
              }
            }
            return opt
          }),
        }
      }
      return filter
    })
  )
}
